import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode4({ name }) {
  return <ReferanceAsyncSelect name={name} labelCategory="KEMER KARTI" />
}
